<template>
  <div class="d-flex flex-column" v-if="model">
    <div class="container-fluid">
      <div class="d-flex align-items-center">
        <back-button class="mr-2" to="/admin/models"/>
        <h1 class="mr-auto">{{model.name}}</h1>
        <btn-action class="btn btn-primary" @click="save">Сохранить</btn-action>
      </div>
    </div>

    <data-table-full-height :data="model.components">
      <el-table-column prop="name" label="Ингредиент"/>
      <el-table-column prop="measure" label="Максимум">
        <template slot-scope="{row}">
          <div class="input-group">
            <input v-model="row.pivot.full" min="0" type="number" class="form-control"/>
            <span class="input-group-append"><span class="input-group-text">{{row.measure}}</span></span>
          </div>
        </template>
      </el-table-column>
    </data-table-full-height>
  </div>
</template>

<script>
  import api from '@/api'

  export default {
    metaInfo () {
      const modelName = this.model ? this.model.name : ''
      return {title: `Модель ${modelName}`}
    },
    props: ['id'],
    methods: {
      save () {
        return api.put(`models/${this.id}`, {
          data: this.model.components.map((component) => ({
            id: component.id,
            full: component.pivot.full,
          })),
        })
      },
    },
    asyncComputed: {
      model () {
        return api.get(`models/${this.id}`).then(({data}) => data)
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/admin/models/_id.vue